export default {
  "content": "<path d=\"M7.74 3.36L6.17 1.79a.99.99 0 00-.71-.29H1.04C.47 1.5 0 1.97 0 2.54v10.92c0 .57.47 1.04 1.04 1.04h13.92c.57 0 1.04-.47 1.04-1.04v-9.1c0-.55-.45-1-1-1H7.74zm7.12 10H1.14V2.64h4.27l1.56 1.57c.19.19.44.29.71.29h7.18v8.86z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};